import { render, staticRenderFns } from "./LearningCenterPhilosophies.vue?vue&type=template&id=43ff09c3&"
import script from "./LearningCenterPhilosophies.vue?vue&type=script&lang=js&"
export * from "./LearningCenterPhilosophies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports